<!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
<template>
  <div class="left-panel">
    <q2-action-group full-width=true orientation="horizontal">
      <q2-btn intent="neutral" style="visibility: hidden;">Sort</q2-btn>
    </q2-action-group>
    <transition-group name="card-fade" tag="div" class="cards-wrapper">
      <div
        v-for="config in configs"
        :key="config.configId"
        :class="['card-wrapper', getCardClass(config)]"
        @click="onCardClick(config)"
      >
        <div class="card-container">
          <q2-card>
             <q2-item>
               <q2-avatar :src="`/v1/configuration/${config.configId}/icon`" icon="person" slot="bullet"></q2-avatar>
               <div slot="header">{{config.configName}}</div>
               <div slot="body">
                   <p>{{config.nickName}}</p>
                   <p>Last build on {{config.lastBuildFormatted}}</p>
               </div>
             </q2-item>
           </q2-card>
        </div>

        <q2-btn
          v-if="authStore.buttons"
          intent="workflow-destroy"
          class="delete-btn"
          @click.stop="onDeleteClick(config)"
        >
          <q2-icon type="trash" />
        </q2-btn>
      </div>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import type { FiConfig } from "../types/build";
import { useAuthStore } from "../stores/authStore";
import { logger } from "../utils/logger";
const authStore = useAuthStore();

const selectedCardId = ref(null);

interface Props {
  configData: FiConfig[] | null;
  fiNumber: string | null;
  selectedConfig: string | null;
}

const props = defineProps<Props>();

/* global defineEmits */

const emit = defineEmits<{
  (e: "selected-config", configId: string): void;
  (e: "delete-config", configId: string): void;
}>();

function getCardClass(build) {
  return build.configId === props.selectedConfig ? "selected-card" : "";
}

const configs = computed(() => {
  const fiData = props.configData;

  logger.debug("🧩 Configs:", fiData);
  if (!fiData) return [];

  return fiData;
});

function onCardClick(build) {
  selectedCardId.value = build.configId;
  emit("selected-config", build.configId); // ✅ emits selected config to FIApps
}
function onDeleteClick(build) {
  const confirmed = window.confirm(
    `Are you sure you want to delete "${build.name}"?`
  );
  if (!confirmed) return;
  logger.debug(`🗑️ Deleting config with ID: ${build.configId}`);
  emit("delete-config", build.configId);
}
</script>

<style scoped>

.left-panel q2-action-group {
    pointer-events: none;
}

.cards-wrapper {
    --tct-card-elevation-2-box-shadow: none;
    --tct-card-border-color: rgb(216.75, 216.75, 216.75);
    --tct-card-border-width: 1px;
    --tct-card-border-style: solid;
    --tct-card-font-color: #404040;
}

.selected-card {
    --tct-card-background: #fdf8ff;
}

.card-container {
    --tct-avatar-border: 1px solid rgb(216.75, 216.75, 216.75);
}

@media (max-width: 768px) {
    .left-panel q2-action-group {
        display: none !important;
        height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .left-panel {
        padding-bottom: 0;
    }

    .cards-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .card-wrapper {
        margin-bottom: 0;
    }

    /* Make selected card more obvious on mobile */
    .selected-card {
        --tct-card-background: #f3e8ff;
        --tct-card-border-color: #9333ea;
        --tct-card-border-width: 2px;
    }

    /* Add visual feedback on tap */
    .card-wrapper {
        transition: transform 0.1s ease;
    }

    .card-wrapper:active {
        transform: scale(0.98);
    }
}
</style>
